import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { MenuHorizontalIcon } from 'cokitchen-icons';
import React from 'react';

export type MealDropdownOptionType = {
  name: string;
  icon: React.ReactNode;
  onClick?: () => void;
  className?: string;
};
const MealDropdownOptions = ({
  dropdownList,
  onClick
}: {
  dropdownList: MealDropdownOptionType[];
  onClick?: () => void;
}) => {
  return (
    <Dropdown
      placement='bottom-end'
      hideArrow
      content={
        <MenuHorizontalIcon
          onClick={onClick}
          className={`absolute top-2 right-2 w-7 h-7 text-white bg-black hover:bg-black bg-opacity-70 rounded-md p-[7.5px] transition-none z-10`}
        />
      }>
      <DropdownList>
        {dropdownList?.map((item, index) => (
          <DropdownItem
            key={index}
            onClick={item?.onClick}
            buttonClassName={`text-gray-6 ${item.className} py-[6px]`}>
            <div className='flex items-center gap-2'>
              <div className='bg-white border border-gray-13 w-[28px] h-[28px] rounded-full flex justify-center items-center'>
                {item.icon}
              </div>
              <p className={`text-gray-6`}>{item?.name}</p>
            </div>
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default MealDropdownOptions;
